import React, { useRef, useState, useEffect, forwardRef } from 'react';
import ReactDatePicker from 'react-datepicker';
import { ptBR } from 'date-fns/locale';
import PropTypes from 'prop-types';

import { useField } from '@unform/core';

import 'react-datepicker/dist/react-datepicker.css';

import { Container as ContainerDate } from './styles';
import { Input, Container, ErrorMessage } from 'components/Input/styles';
import { FiCalendar, FiX } from 'react-icons/fi';

const CustomInput = forwardRef(
  (
    {
      disabled = false,
      error = false,
      placeholderText = '',
      icon = <FiCalendar />,
      value,
      onChange,
      onFocus,
      errorField,
    },
    rest,
  ) => (
    <Container $icon={icon}>
      {!!icon && (
        <div>
          {icon}
          <span />
        </div>
      )}
      <Input
        value={value}
        onFocus={onFocus}
        onChange={onChange}
        placeholder={placeholderText}
        disabled={disabled}
        $icon={icon}
        $error={error || errorField}
        {...rest}
      />
      {(!!error || !!errorField) && (
        <i>
          <FiX />
        </i>
      )}

      <ErrorMessage>{error || errorField}</ErrorMessage>
    </Container>
  ),
);

// CustomInput.defaultProps = {
//   disabled: false,
//   error: false,
//   placeholderText: '',
//   icon: <FiCalendar />,
// };

CustomInput.propTypes = {
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  placeholderText: PropTypes.string,
  value: PropTypes.string,
  errorField: PropTypes.string,
  icon: PropTypes.node,
};

const DatePicker = ({ name, placeholderText, disabled, ...rest }) => {
  const datepickerRef = useRef(null);

  const { fieldName, registerField, defaultValue, error } = useField(name);

  const [date, setDate] = useState(defaultValue || null);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: datepickerRef.current,
      path: 'props.selected',
      clearValue: ref => {
        ref.clear();
      },
    });
  }, [fieldName, registerField]);

  return (
    <ContainerDate>
      <ReactDatePicker
        dateFormat="dd/MM/yyyy"
        ref={datepickerRef}
        selected={date}
        locale={ptBR}
        onChange={date => setDate(date)}
        disabled={disabled}
        customInput={
          <CustomInput
            disabled={disabled}
            placeholderText={placeholderText}
            error={error}
            errorField={rest.errorField}
          />
        }
        {...rest}
      />
    </ContainerDate>
  );
};

export default DatePicker;

// DatePicker.defaultProps = {};

DatePicker.propTypes = {
  name: PropTypes.string,
  placeholderText: PropTypes.string,
  disabled: PropTypes.bool,
};
